import { render, staticRenderFns } from "./ContextSettings.Users.vue?vue&type=template&id=18770ce9&scoped=true&"
import script from "./ContextSettings.Users.vue?vue&type=script&lang=ts&"
export * from "./ContextSettings.Users.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettings.Users.vue?vue&type=style&index=0&id=18770ce9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18770ce9",
  null
  
)

export default component.exports